import { currencyColumn, dateColumn, numberColumn, primaryRelationshipColumn, relationshipColumn, textColumn } from "@api/schema/columnHelpers";
import { objectDefinition } from "@api/schema/supportedObjects";
import RapidReinvestmentSection from "./RapidReinvestmentSection";
import { forwardRef } from "react";

const relationshipType = 'default';
const {pluralName, color, endpoint} = objectDefinition(relationshipType);
const columns = [
    textColumn({column: 'name', label: 'Name', required: true}),
    textColumn({column: 'description', label: 'Description'}),
    dateColumn({column: 'completed_date', label: 'Date Completed', required: true}),
    currencyColumn({column: 'cost_public_dollars', label: 'Public Dollars Used', required: true}),
    currencyColumn({column: 'cost_private_dollars', label: 'Private Dollars Used'}),
];


const PublicImprovements = forwardRef(function PublicImprovements(props, ref) {
    return (
        <RapidReinvestmentSection
            type={relationshipType}
            columns={columns}
            {...props}
            ref={ref}
        />
    )
});

export {PublicImprovements};
